import {
  type UseCartResult,
  type BootstrappingUseCartResult,
} from '../hooks/useCart';
import { getPairingCount, getProductCount } from './query';

export function getInCart(
  productOrPairingId: number,
  isRecipe: boolean,
  useCartResult: UseCartResult | BootstrappingUseCartResult
) {
  const { cart } = useCartResult;
  if (cart === undefined) {
    return false;
  }

  if (isRecipe === true) {
    return getPairingCount(cart, productOrPairingId) > 0;
  }

  return getProductCount(cart, productOrPairingId) > 0;
}

export function getCount(
  productOrPairingId: number,
  isRecipe: boolean,
  useCartResult: Pick<UseCartResult | BootstrappingUseCartResult, 'cart'>
): number {
  const { cart } = useCartResult;
  if (cart === undefined) {
    return 0;
  }

  if (isRecipe === true) {
    return getPairingCount(cart, productOrPairingId);
  }

  return getProductCount(cart, productOrPairingId);
}
